import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import tokens from "../../../shared/theme/tokens";
import { SideNav } from "./SideNav";
import { MobileTabBar } from "./MobileTabBar";

/**
 * Authorized app shell (ui-v2). Desktop (>= md / 990px): persistent left
 * sidebar + wide scrollable content. Below md: content + fixed bottom tab
 * bar (tablets deliberately get the mobile shell).
 *
 * The shell's <main> is the single scroll container — the document body
 * does not scroll (successor to the legacy --vh / overflow:hidden model).
 */
export const AppShell = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: desktop ? "row" : "column",
        height: "100dvh",
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "@supports not (height: 100dvh)": { height: "100vh" },
        backgroundColor: tokens.colors.pageBg,
        overflow: "hidden",
      }}
    >
      {desktop && <SideNav />}
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {children}
      </Box>
      {!desktop && <MobileTabBar />}
    </Box>
  );
};
